<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'FileTypeList' }" class="nav-link">Typy plików</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<FileTypeForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></FileTypeForm>
		</div>
	</b-container>
</template>

<script>
  import FileTypeForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('filetype/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      FileTypeForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'filetype/update/retrieveError',
        retrieveLoading: 'filetype/update/retrieveLoading',
        updateError: 'filetype/update/updateError',
        updateLoading: 'filetype/update/updateLoading',
        created: 'filetype/create/created',
        retrieved: 'filetype/update/retrieved',
        updated: 'filetype/update/updated',
        violations: 'filetype/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('filetype/update/update', {item: this.retrieved, values: values });
      },
      reset () {
        this.$store.dispatch('filetype/update/reset');
        this.$store.dispatch('filetype/create/reset');
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?73698abc